import React from "react";
import { Form, Modal, Row } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import CustomButton from "../../../../components/common/CustomButton";
import DeleteModal from "../../../../components/common/Modal/DeleteModal";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import toastFile from "../../../../Service/ToastFile";
import {
  AddUWMargin,
  DeleteUWMargin,
  GetUWMarginDetails,
  UpdateUWMargin,
} from "../../../../api/User/ACG/MarginApi";
import CustomInputField from "../../../../components/common/CustomInputField";

const schema = Yup.object().shape({
  month_to_Renewal: Yup.number()
    .integer("Number must be an integer")
    .min(0, "Number must be positive")
    .typeError("Please enter a valid number")
    .required("Please enter renewal month"),
  margin: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter margin"),
});

const UWMargin = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isGetData, setIsGetData] = useState(false);
  const [witchAction, setWitchAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const buttonRef = useRef(null);

  const column = [
    {
      title: "Months until Renewal (Remaining)",
      field: "month_to_Renewal",
    },
    {
      title: "Margin",
      field: "margin",
    },
  ];

  useEffect(() => {
    if (showModal === false) {
      setSelectedRowData(null);
    }
    if (isGetData) {
      getMarginDetailsData();
    }
    setIsGetData(false);
  }, [showModal]);

  useEffect(() => {
    getMarginDetailsData();
  }, []);

  const getMarginDetailsData = () => {
    setIsLoading(true);
    GetUWMarginDetails()
      .then((res) => {
        if(res.status === 200 || res.status === 204){
        setData(res.data);
        }
      })
      .catch((err) => console.log({ err }))
      .finally((res) => setIsLoading(false));
  };

  const handleActions = (values) => {
    buttonRef.current.disabled = true;

    const { month_to_Renewal, margin } = values;
    const payload = {
      id: 0,
      month_to_Renewal: +month_to_Renewal,
      margin: +margin,
    };

    if (witchAction === "add") {
      AddUWMargin(payload).then((res) => {
        if(res.status === 200 || res.status === 204){
        setIsGetData(true);
        toastFile("new");
        setShowModal(false);
        }else if (res?.response?.status === 404) {
          toastFile('Error adding Margin details.','error');
          setShowModal(false);
        }
      });
    } else if (witchAction === "update") {
      UpdateUWMargin(selectedRowData.id, {
        ...payload,
        id: selectedRowData.id,
      }).then((res) => {
        if(res.status === 200 || res.status === 204){
        setIsGetData(true);
        toastFile("update");
        setShowModal(false);
        }else if (res?.response?.status === 400) {
          toastFile(res?.response?.data,'error');
          setShowModal(false);
        }
      });
    }
  };

  return (
    <div>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            {witchAction === "add"
              ? "Add "
              : witchAction === "update"
              ? "Update "
              : "Delete "}
            UW Margin
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {witchAction === "delete" ? (
            <DeleteModal
              onClickYes={() => {
                DeleteUWMargin(selectedRowData?.id).then((res) => {
                  if(res.status === 200 || res.status === 204){
                  toastFile("delete");
                  setIsGetData(true);
                  setShowModal(false);
                  }
                });
              }}
              onClickNo={() => setShowModal(false)}
            />
          ) : (
            <Formik
              validationSchema={schema}
              onSubmit={handleActions}
              initialValues={{
                month_to_Renewal: +(selectedRowData?.month_to_Renewal ?? 0),
                margin: +(selectedRowData?.margin ?? 0),
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                errors,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <Row className="mb-2 gap-3">
                    {/* <Form.Group>
                      <Form.Label
                        className="text-nowrap"
                        style={Fontstyling.label}
                      >
                        Months until Renewal (Remaining)
                      </Form.Label>
                      <Form.Control
                        className="py-1 rounded-0"
                        style={Fontstyling.label}
                        name={"month_to_Renewal"}
                        value={values.month_to_Renewal}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        type="number"
                        placeholder="Months until Renewal (Remaining)"
                        isInvalid={
                          touched.month_to_Renewal && errors.month_to_Renewal
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.month_to_Renewal}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group>
                      <Form.Label
                        className="text-nowrap"
                        style={Fontstyling.label}
                      >
                        Margin
                      </Form.Label>
                      <Form.Control
                        className="py-1 rounded-0"
                        style={Fontstyling.label}
                        name={"margin"}
                        value={values.margin}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        type="number"
                        placeholder="Margin"
                        isInvalid={touched.margin && errors.margin}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.margin}
                      </Form.Control.Feedback>
                    </Form.Group> */}
                    <CustomInputField
                      label="Months until Renewal (Remaining)"
                      name="month_to_Renewal"
                      maxLength={2}
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      isRequired
                    />
                    <CustomInputField
                      label="Margin"
                      name="margin"
                      maxLength={10}
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      isRequired
                    />
                  </Row>
                  <div className="d-flex align-items-center justify-content-end gap-3 my-4">
                    <button
                      ref={buttonRef}
                      style={Fontstyling.savebutton}
                      type="submit"
                    >
                      save
                    </button>
                    <button
                      style={Fontstyling.cancelbutton}
                      type="reset"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                  <span className="text-success" style={{fontSize:"12px"}}>
                    * No special characters are allowed
                  </span>
                </Form>
              )}
            </Formik>
          )}
        </Modal.Body>
      </Modal>
      <div className="text-end py-3 border-bottom">
        <CustomButton
          onClick={() => {
            setWitchAction("add");
            setShowModal(true);
          }}
        >
          Add UW Margin
        </CustomButton>
      </div>
      <CustomMaterialTable
        column={column}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={setWitchAction}
        setSelectedRowData={setSelectedRowData}
        setShowModal={setShowModal}
        isLoading={isLoading}
      />
    </div>
  );
};

export default UWMargin;
